import { Link } from "react-router-dom";
import { Shield, AlertTriangle, XCircle } from "lucide-react";

const StatusBadge = ({ status }) => {
  const config = {
    undetected: {
      icon: Shield,
      label: "Undetected",
      className: "status-undetected",
      dotClass: "bg-[#00FF66]"
    },
    updating: {
      icon: AlertTriangle,
      label: "Updating",
      className: "status-updating",
      dotClass: "bg-[#F5A623]"
    },
    detected: {
      icon: XCircle,
      label: "Detected",
      className: "status-detected",
      dotClass: "bg-[#FF3B30]"
    }
  };

  const { label, className, dotClass } = config[status] || config.undetected;

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1 text-xs uppercase tracking-wider ${className}`}>
      <span className={`w-2 h-2 rounded-full ${dotClass} status-pulse`} />
      {label}
    </div>
  );
};

const ProductCard = ({ product }) => {
  const safeFeatures = Array.isArray(product.features) ? product.features : [];

  return (
    <Link
      to={`/products/${product.id}`}
      className="product-card block bg-[#0a0a12] border border-white/5 overflow-hidden group"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={product.image_url || "https://images.pexels.com/photos/33888376/pexels-photo-33888376.jpeg"}
          alt={product.name}
          className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a12] to-transparent" />
        <div className="absolute top-3 right-3">
          <StatusBadge status={product.status} />
        </div>
      </div>

      <div className="p-5">
        <p className="text-[#A1A1AA] text-xs uppercase tracking-wider mb-1">
          Premium Product
        </p>

        <h3 className="font-heading text-lg text-white mb-3">
          {product.name}
        </h3>

        <div className="flex flex-wrap gap-2 mb-4">
          {safeFeatures.slice(0, 3).map((feature, idx) => (
            <span key={idx} className="feature-tag text-xs">
              {feature}
            </span>
          ))}
          {safeFeatures.length > 3 && (
            <span className="feature-tag text-xs">+{safeFeatures.length - 3}</span>
          )}
        </div>

        <div className="flex items-baseline gap-2">
          <span className="price-tag text-[#4F7CFF] text-xl font-bold">
            ${product.price_daily ?? 0}
          </span>
          <span className="text-[#A1A1AA] text-sm">/day</span>
        </div>
      </div>
    </Link>
  );
};

export { ProductCard, StatusBadge };
export default ProductCard;